import React, { Component } from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Carousel from "react-multi-carousel";
import CarouselEdition from "../../Components/Edition/CarouselEdition";
import "react-multi-carousel/lib/styles.css";
// import MainImage from "../../../Assets/img/Group 2660.svg";
import MainImage from "../../../Assets/img/hall_of_fame.svg";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";
import prize_mobile from "../../../Assets/img/prize_mobile.png";
import second_prize from "../../../Assets/img/second_prize.png";
import third_prize from "../../../Assets/img/third_prize.png";
import fourth_prize from "../../../Assets/img/fourth_prize.png";
import { make_request } from "../../Utils/Utils";


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

class HallOfFame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editions: "",
      currentEdition: "",
    };
  }

  async componentDidMount() {
    let responseJson = await make_request({
      path: 'hall_of_fame',
      method: "GET",
    });
    if (responseJson) {
      if (responseJson.status === "success") {
        this.setState({
          editions: responseJson.editions,
          currentEdition: responseJson.editions[0],
        });
      }
    }
  }

  rankStyle(finalist) {
    let classNames = ["col-6"];
    if (finalist.rank === 1) {
      classNames.push("rankone");
    } else if (finalist.rank === 2) {
      classNames.push("ranktwo");
    } else if (finalist.rank === 3) {
      classNames.push("rankthree");
    } else if (finalist.rank === 4) {
      classNames.push("rankfour");
    } else if (finalist.prize) {
      classNames.push("crown");
    }

    if (finalist.prize) {
      classNames.push("hover_pricebox");
    }

    return classNames.join(" ");
  }
  hallOfFameEdition = (id) => {
    if (this.state.editions) {
       let edition = this.state.editions.filter((edition) => edition.id === id);
      this.setState({
        currentEdition: edition[0],
      });
    }
  }

  render() {
    // const { name, year, finalists, description} = this.state;
    return (
      <div className="HallOfFrame innerBody">
        <Header />
        <div className="container edition_slider">
          <div className="row mt-3">
            <h3 className="title m-auto pt-4 pb-4">HALL OF FAME</h3>
            <img src={MainImage} alt="" className="hof_banner m-auto" />
          </div>
          <br />
          <p className="mt-3 hof_txt">
            A hero is someone who has given his or her life to something bigger
            than oneself. Once our event completes, here will lie the names of a
            few passionate players, who will have sacrificed food, sleep,
            girlfriends/boyfriends, to achieve one focussed goal - to get on to
            the Puzzled Hall of Fame. These brave soldiers' names will be etched
            in our coveted Hall of fame forever.
          </p>

          <Carousel responsive={responsive}>
            {this.state.editions &&
              this.state.editions.map((edition) => (
                <CarouselEdition
                  key={edition.id}
                  editionName={edition.name}
                  editionId={edition.id}
                  year={edition.year}
                  loadEdition={this.hallOfFameEdition}
                  active={this.state.currentEdition.id == edition.id ? "true" : ""}
                />
              ))}
          </Carousel>

          <div className="row mt-4 section-table">
            <div className="col">
              <div className="table-responsive card body-card border-0 mt-3 p-2">
                <table className="table mt-3 mb-0">
                  <thead className="thead-yellow">
                    <tr>
                      <th scope="col" className="rank">
                        {" "}
                        &nbsp; &nbsp; Rank
                      </th>
                      <th scope="col" className="name">
                      Display name
                      </th>
                      <th scope="col" className="country">
                      Accolades and Brickbats
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.currentEdition &&
                      this.state.currentEdition.finalists.map((finalist) => {
                        return (
                          <tr key={finalist.rank}>
                            <td className="rank row">
                              <div className={this.rankStyle(finalist)}>
                                {finalist.prize && (
                                  <span className="text-center">
                                    <h4>
                                      {" "}
                                      <b> WINNER </b> <br /> Summer Edition’20{" "}
                                    </h4>
                                    <img
                                      height="55%"
                                      width="30%"
                                      src={prize_mobile}
                                      alt="first_prize"
                                    />
                                    <h6 className="mt-1 ml-1">ONEPLUS NORD</h6>
                                  </span>
                                )}
                              </div>
                              <div className="col-6"> #{finalist.rank}</div>
                            </td>
                            <td className="username">
                              {" "}
                              {finalist.display_name}{" "}
                            </td>
                            <td className="country"> {finalist.comment} </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bg-base mt-4">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                  <div className="position-relative  flex-column flex-md-row align-items-center">
                    <div className="h3 text-center mb-md-0">
                      <span>Are you up for the challenge?</span> Sign up now and
                      start cracking{" "}
                      <a
                        href="/register"
                        className="btn btn-lg btn-yellow ml-5"
                      >
                        REGISTER
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-powered-by pt-4 pb-4">
          <div className="container">
            <div className="row mt-3">
              <div className="col-lg-6 col-md-12 col-12">
                <h4>They make us run this game</h4>
                <p>
                  The generous contributions of our corporate sponsors give us
                  the ability to do so much more. These businesses and
                  organizations find value in our work and support us. If you
                  would like to sponsor, do get in touch.
                </p>
              </div>
              <div className="col-lg-6 col-md-12 col-12 powered_by ">
                <div className="container">
                  <div className="row">
                    <div className="col-4 offset-2">
                      <a
                        href="https://autoattend.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <img src={autoattend} alt="" />{" "}
                      </a>
                    </div>
                    <div className="col-4">
                      <a
                        href="https://www.hashtagtechnologies.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <img src={hastag} alt="" />{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid bg-base">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                  <div className="position-relative flex-column flex-md-row align-items-center">
                    <div className="h3 text-center mb-md-0">
                      Check out the <strong>Exciting Prizes</strong> for our
                      Hall of Famers{" "}
                      <a href="/prizes" className="btn btn-lg btn-yellow ml-5">
                        PRIZES
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default HallOfFame;
